






























import Vue from 'vue';
import { mixin as clickaway } from 'vue-clickaway';

export default Vue.extend({
    name: 'AddToCalendarButton',
    mixins: [clickaway],
    data() {
        return {
            open: false,
        };
    },
    props: {
        dateStart: {
            type: Date,
            required: true,
        },
        dateEnd: {
            type: Date,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },

        dark: Boolean,
        green: Boolean,
        large: Boolean,
        outline: Boolean,
        uppercase: Boolean,
    },
    computed: {
        details(): string {
            const url = window.location.href;
            return `${url}\n\n${this.description}`;
        },
        googleLink(): string {
            const [start, end] = this.getFormattedDates();

            const args = {
                action: 'TEMPLATE',
                text: this.title,
                dates: `${start}/${end}`,
                details: this.details,
            };
            const url = new URL('https://www.google.com/calendar/render');

            for (const [key, value] of Object.entries(args)) url.searchParams.append(key, value);

            return url.toString();
        },
        yahooLink(): string {
            const [start, end] = this.getFormattedDates();

            // Format: https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/master/services/yahoo.md
            const args = {
                v: '60',
                title: this.title,
                desc: this.details,
                st: start,
                et: end,
            };
            const url = new URL('http://calendar.yahoo.com');

            for (const [key, value] of Object.entries(args)) url.searchParams.append(key, value);

            return url.toString();
        },
        appleLink(): string {
            const [start, end] = this.getFormattedDates();

            // Format: https://icalendar.org/
            const lines = [
                'data:text/calendar;charset=utf8,BEGIN:VCALENDAR',
                'VERSION:2.0',
                'BEGIN:VEVENT',
                `URL:${window.location.href}`,
                `DTSTART:${start}`,
                `DTEND:${end}`,
                `SUMMARY:${this.title}`,
                `DESCRIPTION:${this.details}`,
                'END:VEVENT',
                'END:VCALENDAR',
            ];
            return encodeURI(lines.join('\n'));
        },
        outlookLink(): string {
            return this.appleLink;
        },
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        clickOutside() {
            if (!this.open) {
                return;
            }
            this.open = false;
        },
        getFormattedDates(): string[] {
            return [
                new Date(this.dateStart).toISOString().replaceAll(/-|:|(\.\d+)/g, ''),
                new Date(this.dateEnd).toISOString().replaceAll(/-|:|(\.\d+)/g, ''),
            ];
        },
    },
});
